<template>
    <HomeComponent id="home" :data-aos-once="dataAosOnce" />
    <AboutComponent id="about" :data-aos-once="dataAosOnce" />
    <StepByStepComponent id="step-by-step" :data-aos-once="dataAosOnce" />
    <ServicesComponent id="services" :data-aos-once="dataAosOnce" />
    <OurAlliesComponent id="our-allies" :data-aos-once="dataAosOnce" />
    <OurTeamComponent id="our-team" :data-aos-once="dataAosOnce" />
    <TestimonialsComponent id="testimonials" :data-aos-once="dataAosOnce" />
    <ContactComponent id="contact" :data-aos-once="dataAosOnce" />
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
    data() {
        return {
            dataAosOnce: true,
        }
    },
    components: {
        HomeComponent: defineAsyncComponent(() => import('../components/HomeComponent.vue')),
        AboutComponent: defineAsyncComponent(() => import('../components/AboutComponent.vue')),
        StepByStepComponent: defineAsyncComponent(() => import('../components/StepByStepComponent.vue')),
        ServicesComponent: defineAsyncComponent(() => import('../components/ServicesComponent.vue')),
        OurAlliesComponent: defineAsyncComponent(() => import('../components/OurAlliesComponent.vue')),
        OurTeamComponent: defineAsyncComponent(() => import('../components/OurTeamComponent.vue')),
        TestimonialsComponent: defineAsyncComponent(() => import('../components/TestimonialsComponent.vue')),
        ContactComponent: defineAsyncComponent(() => import('../components/ContactComponent.vue')),
    }
}
</script>

<style lang="scss">
@import "@/styles/catapultstyle.scss";
</style>
